import { Box, Button, Checkbox, FormControlLabel, Switch, Typography } from "@mui/material";
import DialogWrapper from "components/DialogWrapper";
import { snack } from "components/toast";
import { useEffect, useState } from "react";
import { DialogProps } from "types";
import CachedIcon from "@mui/icons-material/Cached";

interface Props extends DialogProps {
  onSelectionChange: (selectedValues: string[]) => void;
  comOnSelectionChange: (selectedValues:string[])=>void;
  onSync: any;
  autClientDetails?: any;
}

const options = [
  { label: "Profile", value: "P" },
  { label: "My CA's/Forms", value: "F" },
  // { label: "My Chartered Accountant(s)", value: "MCA" },
  { label: "e-Challan", value: "EC" },
  { label: "Returns", value: "R" },
  { label: "Returns With Attachments", value: "RWA" },
  { label: "Outstanding Demand", value: "OD" },
  { label: "e-Proceedings (Self & of Other PAN/TAN)", value: "EP" },
];

const complianceOptions = [
  { label: "e-Campaign", value: "e-Cam" },
];

function SelectModulePopUp(props: Props) {
  const { open, setOpen, onSelectionChange, onSync, autClientDetails, comOnSelectionChange } = props;
  const [selectedValues, setSelectedValues] = useState<string[]>([]);
  const [complianceSelectedValues, setComplianceSelectedValues] = useState<string[]>([]);

  const [selectAll, setSelectAll] = useState(false);
  const [complianceSelectAll, setComplianceSelectAll] = useState(false)

  useEffect(() => {
    if (selectAll) {
      const selectedArry = options.map((option) => option.value)
      setSelectedValues([...selectedArry]);
      onSelectionChange(selectedArry)
    } else {
      setSelectedValues([]);
    }
  }, [selectAll]);

  useEffect(() => {
    if (complianceSelectAll) {
      const selectedArry = complianceOptions.map((option) => option.value)
      setComplianceSelectedValues([...selectedArry]);
      comOnSelectionChange(selectedArry)
    } else {
      setComplianceSelectedValues([]);
    }
  }, [complianceSelectAll]);
  

  useEffect(() => {
    setSelectedValues([])
    setSelectAll(false)
    setComplianceSelectAll(false)
    setComplianceSelectedValues([])
  }, [open])

  const handleCheckboxChange = (value: string) => {
    const currentIndex = selectedValues.indexOf(value);
    const newSelectedValues = [...selectedValues];

    if (currentIndex === -1) {
      newSelectedValues.push(value);
    } else {
      newSelectedValues.splice(currentIndex, 1);
    }

    setSelectedValues(newSelectedValues);
    onSelectionChange(newSelectedValues);
  };

  const handleComplianceCheckboxChange = (value: string) => {
    const currentIndex = complianceSelectedValues.indexOf(value);
    const newSelectedValues = [...complianceSelectedValues];

    if (currentIndex === -1) {
      newSelectedValues.push(value);
    } else {
      newSelectedValues.splice(currentIndex, 1);
    }

    setComplianceSelectedValues(newSelectedValues);
    comOnSelectionChange(newSelectedValues);
  };

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (selectedValues.length > 0 || complianceSelectedValues.length > 0) {
      onSync();
      // setSelectedValues([]);
    } else {
      snack.error("Please select atleast one module")
    }

  };

  const handleCancel = () => {
    setSelectedValues([]);
    setComplianceSelectedValues([]);
    setOpen(false);
  };

  return (
    <DialogWrapper title="Select Income Tax Modules" open={open} setOpen={setOpen} >
      <form onSubmit={handleSubmit}>
        <Box mt={2}>

          <FormControlLabel
            control={
              <Switch
                checked={selectAll}
                onChange={() => setSelectAll(!selectAll)}
                color="primary"
              />
            }
            label="Select All"
          />
          <Box mb={2}>
            {options.map((option) => (
              <FormControlLabel
                key={option.value}
                control={
                  <Checkbox
                    checked={selectedValues.includes(option.value)}
                    onChange={() => handleCheckboxChange(option.value)}
                  />
                }
                label={option.label}
              />
            ))}
          </Box>
            <FormControlLabel
            control={
              <Switch
                checked={complianceSelectAll}
                onChange={() => setComplianceSelectAll(!complianceSelectAll)}
                color="primary"
                disabled={autClientDetails?.isComplianceApplicable ? false : true}
              />
            }
            label="Select All"
          />
          <Box mb={2}>
            {complianceOptions.map((option) => (
              <FormControlLabel
                key={option.value}
                control={
                  <Checkbox
                    checked={complianceSelectedValues.includes(option.value)}
                    onChange={() => handleComplianceCheckboxChange(option.value)}
                    disabled={autClientDetails?.isComplianceApplicable ? false : true}
                  />
                }
                label={option.label}
              />
            ))}
          </Box>
          {!autClientDetails?.isComplianceApplicable && (
            <Box>
              <Typography mt={1} fontSize={"10px"} >
                <span style={{ color: "red" }}> **Not Applicable for COMPLIANCE Sync.</span> <br />
                  To Sync, enable COMPLIANCE.
            </Typography>
          </Box>)}
          <Box>
            <Typography mt={1} fontSize={"10px"}>
              <span style={{ color: "red" }}>Disclaimer: </span> <br />
              1. It is recommended that you refrain from logging in to the Income Tax
              portal on a second device while automation processes are running in
              the background. This will help to avoid any potential disruptions or errors
              that may occur due to conflicting sessions.
            </Typography>
            <Typography mt={0.5} fontSize={"10px"}>
              2. If a Client’s previous sync status shows "Invalid Credentials",
              the application will automatically cease all further synchronization
              attempts to the respective clients. This is a security measure designed to prevent the account
              from being locked by the portal due to repeated failed login attempts.
              Syncing will resume at the next scheduled interval once the credentials have been updated.
            </Typography>
          </Box>
          <Box display="flex" flexDirection="row" gap={10} mt={2}>
            <Button
              onClick={handleCancel}
              style={{ width: "100%" }}
              color="error"
              variant="outlined"
            >
              Cancel
            </Button>
            <Button
              style={{ width: "100%" }}
              type="submit"
              size="large"
              color="primary"
              variant="contained"
              startIcon={<CachedIcon />}
            >
              Start SYNC
            </Button>
          </Box>
        </Box>
      </form>
    </DialogWrapper>
  );
}

export default SelectModulePopUp;
